import { LocalStorageKeys } from '@/app'
import { AppStatus, useAppSelector } from '@/redux'
import { APIClient } from '@/services'
import { Profile } from '@/types'
import { LocalStorage, toggleOnboardingQuestionsVisibility } from '@/utils'
import { onUpdate } from '@codeleap/common'
import { TypeGuards } from '@codeleap/types'
import { useLocation } from '@reach/router'
import { useEffect, useRef } from 'react'

const routesToAvoid = ['/profile/settings/']

export const useOpenOnboardingQuestions = (profile?: Profile) => {
  const { onboardingQuestionsWasAppeared } = useAppSelector(s => s.Session)
  const { pathname } = useLocation()

  const isResolved = useRef(false)

  const updateProfile = APIClient.Session.useUpdateProfile()

  const getStorageData = () => {
    return JSON.parse(LocalStorage.getItem(LocalStorageKeys.ONBOARDING_QUESTIONS))
  }

  const shouldOpenModal = () => {
    const storage = getStorageData()
    const profileAnswers = profile?.climate_actionability && profile?.climate_priority

    return (
      TypeGuards.isNull(storage) &&
      !profileAnswers &&
      !onboardingQuestionsWasAppeared &&
      !routesToAvoid.includes(pathname)
    )
  }

  const shouldSaveData = () => {
    const storage = getStorageData()
    return !TypeGuards.isNil(profile) && !TypeGuards.isNil(storage) && !isResolved.current
  }

  useEffect(() => {
    if (shouldOpenModal()) {
      AppStatus.setModal(['onboardingQuestions', true])
      toggleOnboardingQuestionsVisibility()
      return
    }

    if (shouldSaveData()) {
      isResolved.current = true
      updateProfile.mutateAsync(getStorageData()).then(() => {
        LocalStorage.removeItem(LocalStorageKeys.ONBOARDING_QUESTIONS)
      })
    }
  }, [profile, pathname])
}
